import {useEffect, useRef, useState} from "react";

import baseUrl from "../../../../baseUrl";
import {requester} from "../../../../services/requester";
import {AreaField} from "./AreaField";
import {useCloseForm} from "../useCloseForm";

// Н5 — екранът „Други площи". След разделянето тук остават само:
//   • Други(−) — намалява правното основание (сегашното поле „Други")
//   • Други(+) — НОВО, увеличава го
//   • Корекция — непокътната, със същата функционалност
// Белите петна и пътищата се преместиха на свой таб („БП и пътища").
//
// Формата пише САМО тези полета (PUT /others/values/...) и НЕ пипа отметката за
// прегледани БП/пътища.
//
// Преди това файлът беше 264 реда с формата, написана два пъти — за „Прибави" и
// за „Редактирай". Сега е една форма: сървърът създава реда, ако още го няма,
// тоест клиентът не различава двата случая.
export const OtherNew = ({bullstat, settlement_ekatte, year, onOthersSubmit, othersInfo}) => {
    const request = requester();
    const closeForm = useCloseForm();
    const anchor = useRef(null);
    const [values, setValues] = useState({
        others: 0, others_plus: 0, others_note: "", correction: 0, correction_note: "",
    });
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        setValues({
            others: othersInfo?.others ?? 0,
            others_plus: othersInfo?.others_plus ?? 0,
            others_note: othersInfo?.others_note ?? "",
            correction: othersInfo?.correction ?? 0,
            correction_note: othersInfo?.correction_note ?? "",
        });
    }, [othersInfo]);

    // Н6: превърта до САМАТА форма. Причината бутонът „Редакция" да изглежда
    // счупен беше друга (виж OthersInfo.js), но и това е по-вярно от старото
    // превъртане до дъното на документа.
    useEffect(() => {
        anchor.current?.scrollIntoView({behavior: "smooth", block: "center"});
    }, []);

    const change = (e) => setValues(prev => ({...prev, [e.target.name]: e.target.value}));

    const onSubmit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await request.put(
                `${baseUrl()}/others/values/${year}/${settlement_ekatte}/${bullstat}`,
                {
                    others: Number(values.others) || 0,
                    others_plus: Number(values.others_plus) || 0,
                    others_note: values.others_note,
                    correction: Number(values.correction) || 0,
                    correction_note: values.correction_note,
                });
            onOthersSubmit();
            alert("Данните са записани.");
            closeForm();                     // Р2: обратно най-горе
        } catch (err) {
            alert(err.message || 'Възникна грешка при заявката.');
        } finally {
            setBusy(false);
        }
    };

    return (
        <form onSubmit={onSubmit} ref={anchor}>
            <h5 style={{color: "var(--app-gold)"}}>Други площи</h5>

            <AreaField id="others-plus" label="Други(+)" name="others_plus"
                       min="0" placeholder="Площ, която УВЕЛИЧАВА правното"
                       value={values.others_plus} onChange={change}
                       hint="увеличава правното основание"/>
            <AreaField id="others" label="Други(−)" name="others"
                       min="0" placeholder="Площ, която НАМАЛЯВА правното"
                       value={values.others} onChange={change}
                       hint="намалява правното основание"/>
            <AreaField id="others_note" label="Забележка" name="others_note"
                       type="text" wide placeholder="Забележка към другите площи"
                       value={values.others_note} onChange={change}/>

            <hr className="col-7"/>

            <AreaField id="correction" label="Корекция" name="correction"
                       min="0" placeholder="Въведи коригираща площ"
                       value={values.correction} onChange={change}
                       hint="намалява годната площ"/>
            <AreaField id="correction_note" label="Забележка" name="correction_note"
                       type="text" wide placeholder="Забележка към коригиращата площ"
                       value={values.correction_note} onChange={change}/>

            <button type="submit" className="btn btn-primary mt-3" disabled={busy}>
                {busy ? "Записва се…" : "Запиши"}
            </button>
        </form>
    );
};
